// The signed-in reseller (features/reseller): its shapes come from packages/contracts.
import {
  GetInformationResponse,
  GetProfileResponse,
  SignUpResponse,
  SubmitInformationResponse,
  type SignUpRequest,
} from "@kilat/contracts/reseller";
import {
  AcceptInvitationResponse,
  InviteMemberResponse,
  ListInvitationsResponse,
  ListMembersResponse,
  MemberResponse,
  PreviewInvitationResponse,
  ResendInvitationResponse,
  RevokeInvitationResponse,
  type AcceptInvitationRequest,
  type ChangeMemberRoleRequest,
  type InviteMemberRequest,
} from "@kilat/contracts/members";
import { api } from "@/lib/api-client";

export const getProfile = () => api.request("/api/reseller/profile", { schema: GetProfileResponse });

export const signUp = (application: SignUpRequest) =>
  api.request("/api/reseller/sign-up", { method: "POST", body: application, schema: SignUpResponse });

export const getInformation = () => api.request("/api/reseller/information", { schema: GetInformationResponse });

// `unknown` on purpose: what is sent is what the applicant typed, which the API parses with the
// same contract. The contract's own output is not valid input (an empty website parses to absent).
export const submitInformation = (information: unknown) =>
  api.request("/api/reseller/information", { method: "PUT", body: information, schema: SubmitInformationResponse });

// The team: who is in it, who is invited, and inviting someone.
export const getMembers = () => api.request("/api/reseller/members", { schema: ListMembersResponse });

export const getInvitations = () => api.request("/api/reseller/invitations", { schema: ListInvitationsResponse });

export const inviteMember = (invitation: InviteMemberRequest) =>
  api.request("/api/reseller/invitations", { method: "POST", body: invitation, schema: InviteMemberResponse });

// The invitee's side, before they have an account. The token goes in the body, never a URL.
export const previewInvitation = (token: string) =>
  api.request("/api/reseller/join/preview", { method: "POST", body: { token }, schema: PreviewInvitationResponse });

export const acceptInvitation = (acceptance: AcceptInvitationRequest) =>
  api.request("/api/reseller/join/accept", { method: "POST", body: acceptance, schema: AcceptInvitationResponse });

// An open invitation, sent again or withdrawn; id is its Base62 code.
export const resendInvitation = (id: string) =>
  api.request(`/api/reseller/invitations/${id}/resend`, { method: "POST", schema: ResendInvitationResponse });

export const revokeInvitation = (id: string) =>
  api.request(`/api/reseller/invitations/${id}`, { method: "DELETE", schema: RevokeInvitationResponse });

// A member's role changed, or the member removed; id is their Base62 code from the team list.
export const changeMemberRole = (id: string, change: ChangeMemberRoleRequest) =>
  api.request(`/api/reseller/members/${id}`, { method: "PATCH", body: change, schema: MemberResponse });

export const removeMember = (id: string) => api.request(`/api/reseller/members/${id}`, { method: "DELETE" });
